import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiShow, BiTrash } from "react-icons/bi";
import { Box, IconButton, useDisclosure, useToast } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useApiClient, usePaginationApi } from "../../shared/hooks";
import usePagination from "../../features/admin/usePagination";
import { Header, ModalBox } from "../../shared/components";
import { Table } from "../../features/admin/components";

function ViewBlogsPage() {
    const queryClient = useQueryClient();
    const { getWithPagination } = usePaginationApi();
    const apiClient = useApiClient();
    const { onOpen } = useDisclosure();
    const navigate = useNavigate();
    const [confirm, setConfirm] = useState<boolean>(false);
    const [id, setId] = useState<string | null>(null);
    const [pagination, setPagination] = usePagination();
    const columnHelper = createColumnHelper<any>();
    const toast = useToast();
    const {
      isOpen: isDeleteOpen,
      onOpen: onDeleteOpen,
      onClose: OnDeleteClose,
    } = useDisclosure();
  
    const deleteFn = async (id:string) => {
      try{
        const response = await apiClient.deleteBlog(id);

        if(response.status){
          toast.closeAll();
          toast({
            title: "Success",
            description:"Blog Deleted Successfully",
            status: "success",
            isClosable: true,
            duration: 2000,
          });
          queryClient.invalidateQueries(["blog-list", pagination]);
  
        }
      }catch(error){
         console.log(error)
      }finally{
        setConfirm(false);
        setId(null)
        OnDeleteClose()
      }
      
    }
    const { isLoading, data,} = useQuery({
      queryKey: ["blog-list", pagination],
      queryFn: async () => {
        const response: any = await getWithPagination("HOSTEL_SERVICE", "/api/blogs/by-category", {
          perpage: pagination.perPage,
          page: pagination.currentPage,
          search: pagination.searchTerm,
        });

        if (!response?.status) {
          throw new Error(response?.message);
        }

        return {
          data: response.data.data,
        };
      },
      keepPreviousData: true
    });
    useEffect(() => {
      if (data) {
        setPagination({
          ...pagination,
          currentPage: data?.data?.current_page?? 1,
          perPage: pagination.perPage ??20,
          total: data?.data?.total_items ?? 0,
          totalPages: data?.data?.total_pages ?? 0,
        })
      }
    }, [data])
    
    useEffect(() => {
      if (confirm && id) {
        void deleteFn(id);
        setConfirm(false);
      }
    }, [confirm]);
    const onOpenModal = (rowData: any) => {
      onOpen();
      navigate(`/blog/${rowData.id}`);
    };
   const onDelete=(rowData:any)=>{
    deleteFn(rowData.id);
   }

    const columns = [
      columnHelper.accessor("SN", {
        header: () => <span>SN</span>,
        size: 50,
        cell: (info: any) => {
          return (
            <span>
              {info.row.index + (pagination?.currentPage - 1) * pagination?.perPage + 1}
            </span>
          );
        },
      }),
      
      columnHelper.accessor("title", {
        id: "title",
        header: () => <span>{"Title"}</span>,
        size: 200,
        cell: (info: any) => {
          return <span>{info?.row?.original?.title}</span>;
        },
      }),
  
      columnHelper.accessor("updated_at", {
        id: "created_at",
        header: () => <span>{"created At"}</span>,
        size: 200,
        cell: (info: any) => {
          return (
            <span>
              {(info?.row?.original?.updated_at &&
                moment(
                  info?.row?.original?.updated_at,
                  "YYYY-MM-DDTHH:mmZ"
                ).format("MMMM D, YYYY")) ||
                ""}
            </span>
          );
        },
      }),
      columnHelper.accessor("action", {
        id: "action",
        header: () => <span>{"Action"}</span>,
        size: 200,
        cell: (info: any) => {
          return (
            <span >
              <IconButton
                aria-label="View"
                icon={<BiShow size={"24px"} />}
                onClick={() => onOpenModal(info.row.original)}
                marginRight="4px"
              />
               <IconButton
                aria-label="Trash"
                icon={<BiTrash size={"24px"} color="red" />}
                onClick={() => {
                  setId(info?.row?.original?.id);
                  onDeleteOpen();
                }}
              />
            </span>
            
          );
        },
      }),
    ];
  
    return (
      <Box>
        <Header
          buttonIcon={null}
          header={"Blog-list"}
          buttonText={undefined}
          handleOpen={onOpen}
        />
        <Table
          title="List of Blogs"
          columns={columns}
          rowData={data?.data?.data_list ?? []}
          pagination={pagination}
          setPagination={setPagination}
          loading={isLoading}
        />
        <ModalBox
        isOpen={isDeleteOpen}
        handleOpen={onDeleteOpen}
        handleClose={OnDeleteClose}
        title="Delete Blog"
        type="delete"
        confirm={confirm}
        setConfirm={setConfirm}
        size="sm"
      />
      </Box>
    );
  }
  
export default ViewBlogsPage;
  